<template>
    <div>
        <div class="contain">
            <img class="imgs" src="../../../assets/c31/1.png" />
            <img class="imgs" src="../../../assets/c31/2.png" />
            <img class="imgs" style="cursor: pointer;" src="../../../assets/c31/3.png" @click="openBlog(1)"/>
            <img class="imgs" style="cursor: pointer;" src="../../../assets/c31/4.png" @click="openBlog(2)"/>
            <img class="imgs" style="cursor: pointer;" src="../../../assets/c31/5.png" @click="openBlog(3)"/>
            <img class="imgs" src="../../../assets/c31/6.png" />
            <img class="imgs" src="../../../assets/c31/7.png" />
            <img class="imgs" style="cursor: pointer;" src="../../../assets/c31/8.png" @click="openModal"/>
            <img class="imgs" src="../../../assets/c31/9.png" />
            <img class="imgs" src="../../../assets/c31/10.png" />
            <img class="imgs" src="../../../assets/c31/11.png" />
            <img class="imgs" src="../../../assets/c31/12.png" />
            <img class="imgs" src="../../../assets/c31/13.png" />
            <img class="imgs" style="cursor: pointer;" src="../../../assets/c31/14.png" @click="openModal" />
            <img class="imgs" src="../../../assets/c31/15.png" />
            <a href="https://official.soldoc.co.kr/api/v1/click/3udchJPqqkKRvDzYFPhrEA?cb_1={click_id}&cb_2={ad_service_id}&cb_3={placement_id}&cb_4={mbrseq}&m_adid={google_aid}{apple_ifa}&m_campaign={campaign_id}&m_adgroup_id={ad_group_id}&m_creative={creative_id}&adv_campaign=barosoldoc&adv_ad=all&adv_adgroup=promotion&adv_creative=%EB%9E%9C%EB%94%A9%ED%8E%98%EC%9D%B4%EC%A7%80_%EB%B3%B4%EC%8A%B5%EC%A0%9C_viewid=32_250205&abx_tracker_id=3udchJPqqkKRvDzYFPhrEA" target="_blank" title="새 창 열림" class="c3_floot_cta">
                <img src="../../../assets/c31/img-cta-btn.png" alt="" />
            </a>
        </div>
        <div class="custommodal" v-if="isModal">
            <div class="section">
                <div class="section-body">
                     <div class="header">
                        <img class="close-button" src="../../../assets/c31/close_button.png" @click="closeModal"/>
                        <span class="modalheader">당일배송 서비스 지역 안내</span>
                    </div>
                    <div class="content">
                        <span class="label">전 지역 서비스 가능한 지역</span>
                        <span class="text1">서울, 성남, 부천, 안양, 과천</span>
                        <span class="label">일부 지역 서비스 가능한 지역</span>
                        <span class="text2">
                            <span>
                                <strong>인천광역시 :</strong> 계양구(계산동, 귤현동, 동양동, 박촌동, 방축동, 병방동, 서운동, 오류동, 용종동,
                                임학동, 작전동, 장기동, 효성동), 남동구(간석동, 구월동, 만수동, 서창동),
                                미추홀구(관교동, 도화동, 문학동, 숭의동, 용현동, 주안동, 학익동),  부평구(갈산동, 구산동, 부개동, 부형동, 산곡동, 삼산동, 십정동, 일신동, 청천동),
                                연수구(동춘동, 선학동, 송도동, 연수동, 옥련동, 청학동)
                            </span>
                            <span>
                                <strong>고양시 :</strong> 덕양구(강매동, 덕은동, 동산동, 삼송동, 성사동, 신원동, 신평동, 원흥동,
                                주교동, 지축동, 토당동, 행신동, 화정동), 일산동구(마두동, 백석동, 설문동,
                                식사동, 장항동, 정발산동, 중산동, 풍동), 일산서구(가좌동, 대화동, 덕이동,
                                일산동, 주엽동, 탄현동)
                            </span>
                            <span>
                                <strong>광명시 :</strong> 광명동, 소하동, 일직동, 철산동, 하안동
                            </span>
                            <span>
                                <strong>구리시 :</strong> 갈매동, 교문동, 수택동, 아천동, 인창동, 토평동
                            </span>
                            <span>
                                <strong>군포시 :</strong> 금정동, 당동, 당정동, 대야미동, 도마교동, 부곡동, 산본동
                            </span>
                            <span>
                                <strong>남양주시 :</strong> 다산동, 도농동, 별내동
                            </span>
                            <span>
                                <strong>수원시 :</strong> 권선구(고색동, 곡반정동, 구운동, 권선동, 금곡동, 당수동, 서둔동,
                                세류동, 오목천동, 입북동, 탑동, 평동, 호매실동), 영통구(망포동, 매탄동, 신동,
                                영통동, 원천동, 이의동, 하동), 장안구(송죽동, 연무동, 영화동, 율전동, 이목동,
                                정자동, 조원동, 천천동, 파장동, 하광교동), 팔달구(고등동, 교동, 구천동, 남수동,
                                남창동, 매교동, 매산로1~3가, 매향동, 복수동, 신풍동, 영동, 우만동, 인계동,
                                장안동, 지동, 화서동)
                            </span>
                            <span>
                                <strong>안산시 :</strong> 단원구(고잔동, 선부동, 신길동, 와동, 원곡동, 초지동), 상록구
                                (건건동, 본오동, 부곡동, 사동, 성포동, 수암동, 월피동, 이동, 일동, 팔곡이동)
                            </span>
                            <span>
                                <strong>용인시 :</strong> 기흥구(공세동, 구갈동, 농서동, 동백동, 마북동, 보라동, 보정동,
                                상갈동, 상하동, 서천동, 신갈동, 언남동, 영덕동, 중동, 청덕동), 수지구
                                (동천동, 상현동, 성복동, 신봉동, 죽전동, 풍덕천동)
                            </span>
                            <span>
                                <strong>의왕시 :</strong> 고천동, 내손동, 삼동, 오전동, 왕곡동, 월암동, 청계동, 포일동, 학의동
                            </span>
                            <span>
                                <strong>하남시 :</strong> 감북동, 감이동, 감일동, 덕풍동, 망월동, 선동, 신장동, 창우동, 풍산동,
                            학암동
                            </span>
                            <span>
                                <strong>화성시 :</strong> 반월동, 능동, 목동, 반송동, 산척동, 석우동, 송동, 신동, 영천동, 오산동,
                            장지동, 청계동
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'c31',
    data: function()
    {
        return {
            isModal: false
        }
    },
    methods: {
        openBlog: function(index) {
            if(index === 1)
            {
                window.open("https://blog.naver.com/lucky-song/223681970528", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://blog.naver.com/xxeos/223682135006", '_blank')
            }
            else if(index === 3)
            {
                window.open("https://blog.naver.com/lyg315/223676287242", '_blank')
            }
        },
        openModal: function()
        {
            document.body.style.overflow = 'hidden'
            this.isModal = true;
        },
        closeModal: function()
        {
            document.body.style.removeProperty('overflow')
            this.isModal = false;
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 900px;
        padding-bottom: 100px;
    }    
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
    .c3_floot_cta{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 65px;
        width: 775px;
        height: 146px;
        z-index: 10;
        font-size: 38px;
        font-weight: 600;
        line-height: 146px;
        color: #fff;
        text-decoration: none;
    }

    .row {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 59px;
    }
    .custommodal {
        position: fixed;
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        z-index: 99999;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-top: 85px;
        padding-bottom: 66.4px;
        overflow: hidden;
    }
    .section {
        width: 715px;
        height: 100%;
        flex-shrink: 0;
        border-radius: 21.333px;
        background: #FFF;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 4px 6px;
        /* overflow-y: auto; */
        overflow: hidden;
        box-sizing: border-box;
    }
    .section-body {
        position: relative;
        padding: 0 34px;
        overflow-y: auto;
        padding-bottom: 40px;
    }
    .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 39px;
    }
    .close-button {
        position: absolute;
        right: 25px;
        top: 30px;
        width: 44px;
        cursor: pointer;
    }
    .modalheader {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #1A1A1A;
        text-align: center;
        font-family: Pretendard;
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 36px; /* 100% */
        margin-top: 33px;
    }
    .label {
        color: #008DEF;
        text-align: center;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36.267px; /* 151.111% */
        display: inline-flex;
        height: 50px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 68.267px;
        background: #E5F0FC;
        padding: 0 34.133px;
    }
    .text1{
        position: relative;
        padding-left: 24px;
        color: #666;
        font-family: Pretendard;
        font-size: 25.6px;
        font-style: normal;
        font-weight: 400;
        line-height: 40.533px; /* 158.333% */
        margin: 14px 0 34px;
    }
    .text1::before {
        position: absolute;
        left: 0;
        top: -2px;
        display: inline-block;
        content: "•";
    }
    .text2 {
        color: #666;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        letter-spacing: -0.48px;
        margin-top: 23px;
    }
    .text2 strong {
        font-weight: 600;
    }
    .text2 span {
        position: relative;
        display: block;
        padding-left: 20px;
    }
    .text2 span::before {
        position: absolute;
        left: 0;
        top: -2px;
        display: inline-block;
        content: "•";
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/c32.vue